<template>      
   <div>
        <div class="row">
            <div class="input-field col s12">
                <input v-model.lazy="name" id="name" type="text" />
                <label for="name" class="active">Name</label>
            </div>
        </div>
        <div class="row">   
            <div class="input-field col s8">
              <input v-model="email" id="newEmail" type="email" class="validate">
              <label for="newEmail" class="active">Change email/login</label>
            </div>
            <div class="col s4">
              <button class="btn waves-effect waves-light right" v-on:click="changeUsername()">Change
              </button>
            </div>
        </div>
        
        <div class="row">
            <div class="input-field col s8">
                <input id="password" type="password" class="validate" v-model="password">
                <label for="password">Change password</label>
            </div>
            <div class="col s4">
                <button class="btn waves-effect waves-light right" v-on:click="changePassword()">Change
                </button>
            </div>
        </div>
        <div class="row">
            <div class="input-field col s6">
                <label>
                    <input name="gender" type="radio" checked v-model="gender" value="male"/>
                    <span>Male</span>
                </label>
            </div>
            <div class="input-field col s6">
                <label>
                    <input name="gender" type="radio" value="female" v-model="gender"/>
                    <span>Female</span>
                </label>
            </div>
        </div>
      </div>
</template>
<script>
import api from '@/api'
import M from 'materialize-css'
export default {
  name: 'training',
  props: {
    'user': Object,
    'callback': Function
  },
  data: function () {
    return {
      name: this.user.athlete.name,
      email: this.user.athlete.email,
      gender: this.user.athlete.gender,
      password: undefined
    }
  },
  created () {
    this.name = this.user.athlete.name
    this.email = this.user.athlete.email
    this.gender = this.user.athlete.gender
  },
  watch: {
    name: function (val) {
      this.user.athlete.name = val
      api.update(this.user)
      M.toast({html: 'Name changed!'})
    },
    gender: function (val) {
      this.user.athlete.gender = val
      api.update(this.user)
      M.toast({html: 'Gender changed!'})
    }
  },
  methods: {
    changePassword () {
      api.changePassword(this.user, this.password)
        .then(() => {
          M.toast({html: 'Password changed!'})
        })
        .catch((e) => {
          M.toast({html: 'Error, password not changed!'})
        })
    },
    changeUsername () {
      api.changeUsername(this.user, this.email)
        .then(() => {
          M.toast({html: 'Email/login changed!'})
        })
        .catch((e) => {
          M.toast({html: 'Error, Email/login not changed!'})
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/athlete/Infos.vue